import { useEffect, useState } from "react";

import Modal from "react-modal";
import "../assets/css/HeaderWebsite.css";
Modal.setAppElement("#root");

const getThemeFromStorage = () => {
  let theme = true;
  if (localStorage.getItem("theme")) {
    theme = JSON.parse(localStorage.getItem("theme"));
  }
  return theme;
};

function HeaderCalculator(props) {
  const { statusMode, setStatusMode, isLoggedIn, showLogoutButton } =
    props;
  const logopreto = `${process.env.PUBLIC_URL}/LOGOPRETO.png`;
  
  const logobranca = `${process.env.PUBLIC_URL}/LOGOBRANCO.png`;

  const [isDarkMode, setIsDarkMode] = useState(getThemeFromStorage());

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.className = "light-theme";
    } else {
      document.documentElement.className = "dark-theme";
    }
    localStorage.setItem("theme", isDarkMode);
  }, [isDarkMode]);


  return (
    <header
      className={`header d-flex justify-content-between align-items-center navbar navbar-expand-lg navbar-dark ResponsivHeader ${
        statusMode ? "dark-mode" : ""
      }`}
    >
      
      <div className="fw-semibold d-flex align-items-center">
        <a
          className={`text-decoration-none fs-5 me-3 ${
            statusMode ? "textDark" : "text-light"
          }`}
          href="/"
        >
          <img
            src={statusMode ? logobranca : logopreto}
            alt="Logo"
            style={{ height: "37px", width: "auto" }}
            className="imgfullhd"
          />
        </a>
      </div>
      

      <div className="d-flex align-items-center"></div>
    </header>
  );
}

export default HeaderCalculator;
